import styles from './index.module.scss';
import { useBbSolConfigContext } from '@/hooks/useBboSolInfo';
import { useFm } from '@web3/base-hooks';
import ArrowRight from '@/assets/images/bybitsol/arrow-right.svg';
import { Event } from '@/config/track-config';
import { scTrack } from '@web3/base-tracking';

export const DappSection = () => {
  const fm = useFm();
  const {
    solConfig: { dapps },
  } = useBbSolConfigContext();

  if (!dapps || dapps.length === 0) {
    return null;
  }

  const handleClick = (name: string, url: string) => {
    scTrack(Event.Web3UserClick, {
      page_name: 'StakingWeb_BBSOLhomepage',
      button_name: `Defi_Ecosystem_${name}`,
    });
    window.open(url, '_blank');
  };

  return (
    <div className={styles.container}>
      <div className={styles.section}>
        <div className={styles.title}>{fm('proudlyPoweredBy')}</div>
        <div className={styles.partnersGrid}>
          {dapps.map((dapp, index) => (
            <div
              key={index}
              className={styles.partnerCard}
              onClick={() => handleClick(dapp?.name ?? '', dapp?.url ?? '')}
            >
              <img src={dapp.logoUrl} alt={dapp.name} className={styles.logo} />

              <div className={styles.hoverContent}>{dapp.description}</div>

              <div className={styles.viewMore}>
                {fm('viewMore')} <ArrowRight className={styles.arrow} />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
